const ARTICLE_NOTIFICATION_STATUS_TOPIC = 'topics';
const ARTICLE_NOTIFICATION_STATUS_ALL = 'all';

export const ARTICLE_NOTIFICATION_PROPS = {
  frequency: null,
  slug: 'articleNotifications',
  subheader: 'Get an email each time we publish a major article.',
  title: 'Major Articles',
};

export const ARTICLE_NOTIFICATION_STATUSES = [
  ARTICLE_NOTIFICATION_STATUS_TOPIC,
  ARTICLE_NOTIFICATION_STATUS_ALL,
];

export const WEEKLY_DIGEST_PROPS = {
  author: 'The Information',
  frequency: 'Weekly',
  slug: 'weeklyDigest',
  subheader: 'Stay ahead with comprehensive industry insights.',
  title: 'Weekly Digest',
};
